import { render } from "./UnsubscribeToMail.vue?vue&type=template&id=02aa417a"
import script from "./UnsubscribeToMail.vue?vue&type=script&lang=js"
export * from "./UnsubscribeToMail.vue?vue&type=script&lang=js"

import "./UnsubscribeToMail.vue?vue&type=style&index=0&id=02aa417a&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__